export enum Permissions {
  CAMERA = 'camera',
  SCREEN_SHARE = 'screen_share',
  MICROPHONE = 'microphone',
  END_CALL = 'end_call',
  CAPTIONS = 'captions',
  START_SCREEN = 'start_screen',
  BLOCK_HUBSPOT = 'block_hubspot',
  BLOCK_GOOGLE = 'block_google',
  BLOCK_FACEBOOK = 'block_facebook',
  BLOCK_MORPHCAST = 'block_morphcast',
  BLOCK_LOCALHOST_3001 = 'block_localhost_3001',
  BLOCK_LOCALHOST_3000 = 'block_localhost_3000'
}
